module.exports = __webpack_public_path__ + "static/media/3phones.fa7e7f99.svg";